@for (validation of validationMessages | keyvalue; track validation) {
  <div class="error-message" data-test-id="validation-error-component.error-message">
    @if (
      validation.key === 'pattern' || validation.key === 'minlength' || validation.key === 'maxlength') {
      {{ 'validation.' + validation.key | transloco: { value: validation?.value?.requiredLength ?? controlValue } }}
    } @else {
      {{
      'validation.' + validation.key
      | transloco: { value: validation?.value?.min ?? validation?.value?.max ?? validation?.value }
      }}
    }
  </div>
}
